export default __webpack_public_path__ + "static/media/teaching.d3c6fe22.svg";